import { mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Upper Section */}
      <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">

            {/* Brand */}
            <div className="md:col-span-4">
              <span className="text-3xl md:text-4xl font-bold font-heading tracking-tight">
                Vigorbuy
              </span>
              <p className="mt-6 text-foreground-300 text-sm leading-relaxed max-w-xs">
                The ultimate <strong className="text-background-50 font-medium">Vigorbuy Spreadsheet Directory</strong> — helping shoppers discover organized products with verified guides and weekly updates.
              </p>
              {/* Social Icons */}
              <div className="flex items-center gap-4 mt-8">
                {['ri-twitter-x-line', 'ri-instagram-line', 'ri-telegram-line', 'ri-reddit-line'].map((icon) => (
                  <a
                    key={icon}
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50/30 transition-all duration-200 cursor-pointer"
                    aria-label="Social media"
                  >
                    <i className={icon}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="md:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-foreground-400 mb-5">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  { label: 'Spreadsheet', url: mainSiteUrl },
                  { label: 'Guides', url: '/articles/vigorbuy-spreadsheet-complete-guide' },
                  { label: 'Categories', url: mainSiteUrl },
                  { label: 'Safety Tips', url: '/articles/vigorbuy-spreadsheet-complete-guide' },
                ].map((link) => (
                  <li key={link.label}>
                    {link.url.startsWith('/') ? (
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div className="md:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-foreground-400 mb-5">
                Resources
              </h4>
              <ul className="space-y-3">
                {[
                  { label: 'Buying Guide', url: mainSiteUrl },
                  { label: 'QC Tips', url: mainSiteUrl },
                  { label: 'Shipping Info', url: mainSiteUrl },
                  { label: 'FAQ', url: '#' },
                ].map((link) => (
                  <li key={link.label}>
                    {link.url.startsWith('#') ? (
                      <a
                        href={link.url}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Image */}
            <div className="md:col-span-2 flex items-start justify-end">
              <div className="w-32 h-40 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20display%20with%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20lifestyle%20aesthetic%2C%20clean%20composition%2C%20cream%20and%20beige%20palette%2C%20editorial%20fashion%20photography%2C%20artistic%20arrangement%2C%20textured%20fabric%20details&width=300&height=400&seq=footer-img-01&orientation=portrait"
                  alt="Vigorbuy Spreadsheet Lifestyle"
                  title="Vigorbuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800 px-6 md:px-10 lg:px-16 py-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy. All rights reserved. An independent informational resource.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200"
            >
              Kaspreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200"
            >
              Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}